import { ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface'

export const transformFieldValuesToFields = (
  data: ManageFieldsInterface,
  subscriptionId: number,
) => {
  const fields: Record<string, string> = {}

  data.fieldValues.forEach(item => {
    fields[item.contactField.slug] = item.value
  })

  return {
    subscriptionItem: subscriptionId,
    fields,
  }
}
